module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-180x180-cfa5fe0e3cbe490d6c388bf3b7ae6ff1.png";